import { adminTenantId } from '@logto/schemas';
import { useContext } from 'react';

import PageContext from '@/Providers/PageContextProvider/PageContext';

/** Legacy overseas/native values retain native EVA behavior after migration. */
export const getOverseasBrand = (edition?: string) => {
  if (edition === 'overseas-edge0') {
    return 'edge0';
  }
  if (edition === 'overseas-eva' || edition === 'overseas' || edition === 'native') {
    return 'eva';
  }
};

export default function useNativeSignIn() {
  const { experienceSettings } = useContext(PageContext);
  return (
    experienceSettings?.tenantId === adminTenantId ||
    Boolean(getOverseasBrand(experienceSettings?.customContent.evaEdition))
  );
}
